export const getCareerRank = state => state.careerDestination.CareerRank;
export const getRelatedCareers = state =>
  state.careerDestination.RelatedCareers;
export const getOccupationByCluster = state =>
  state.careerDestination.OccupationByCluster;
export const getSavedCareers = state => state?.careerDestination?.SavedCareers;
